import IconButtonStyled from './styled';
import IconButtonProps from './type';
import Icon from '../Icon';

const IconButton = ({ ...props }: IconButtonProps) => {
  const { iconProps } = props;

  return (
    <IconButtonStyled {...props}>
      <Icon {...iconProps} />
    </IconButtonStyled>
  );
};

IconButton.defaultProps = {
  variant: 'primary',
};

export default IconButton;
